import Vue from 'vue'
import VueRouter from 'vue-router'
// import Login from '../components/Login.vue'
// import success from '../components/Success.vue'
// import Home from '../components/Home.vue'
// import Welcome from '../components/Welcome.vue'
// import User from '../components/admin/User.vue'
// import changeRenewal from '../components/Monthly/changeRenewal.vue'
// import insuranceClaims from '../components/insuranceClaims.vue'
// import fpgl from '../components/fpgl.vue'
// import sljl from '../components/sljl.vue'
//懒加载
const Login = () =>
    import ('../components/Login.vue')
const success = () =>
    import ('../components/Success.vue')
const Home = () =>
    import ('../components/Home.vue')
const Welcome = () =>
    import ('../components/Welcome.vue')
const User = () =>
    import ('../components/admin/User.vue')
const bcgsbxbl = () =>
    import ('../components/bcgsbxbl.vue')
const changeRenewal = () =>
    import ('../components/Monthly/changeRenewal.vue')
const nochangeRenewal = () =>
    import ('../components/Monthly/nochangeRenewal.vue')
const bjgwyf = () =>
    import ('../components/Monthly/bjgwyf.vue')
const bjgwyfbj = () =>
    import ('../components/Monthly/bjgwyfbj.vue')
const dwmcbgbq_month = () =>
    import ('../components/Monthly/dwmcbgbq_month.vue')
const yearpay = () =>
    import ('../components/Yearly/yearpay.vue')
const dwmcbgbq_year = () =>
    import ('../components/Yearly/dwmcbgbq_year.vue')
const jdjf = () =>
    import ('../components/jdjf.vue')
const bnjf = () =>
    import ('../components/bnjf.vue')
const bcylbx_year = () =>
    import ('../components/bcylbx_year.vue')
const insuranceClaims = () =>
    import ('../components/insuranceClaims.vue')
const fpgl = () =>
    import ('../components/fpgl.vue')
const sljl = () =>
    import ('../components/sljl.vue')
const bcylsljl = () =>
    import ('../components/bcylsljl.vue')
const bcgssljl = () =>
    import ('../components/bcgssljl.vue')
const bcgsbjsljl = () =>
    import ('../components/bcgsbjsljl.vue')

const xslpsqlc = () =>
    import ('../components/xslpsqlc.vue')

Vue.use(VueRouter)
import Print from 'vue-print-nb'
// 注册
Vue.use(Print)
const routes = [{
        path: '/',
        component: Login
    },
    {
        path: '/success',
        component: success
    }, {
        path: '/login',
        component: Login
    },
    {
        path: '/home',
        component: Home,
        redirect: '/welcome',
        children: [
            { path: '/welcome', component: Welcome },
            { path: '/user', component: User },
            { path: '/bcgsbxbl', component: bcgsbxbl },
            { path: '/changeRenewal', component: changeRenewal, name: 'changeRenewal' },
            { path: '/nochangeRenewal', component: nochangeRenewal, name: 'nochangeRenewal' },
            { path: '/bjgwyf', component: bjgwyf, name: 'bjgwyf' },
            { path: '/bjgwyfbj', component: bjgwyfbj, name: 'bjgwyfbj' },
            { path: '/dwmcbgbq_month', component: dwmcbgbq_month, name: 'dwmcbgbq_month' },
            { path: '/yearpay', component: yearpay, name: 'yearpay' },
            { path: '/dwmcbgbq_year', component: dwmcbgbq_year, name: 'dwmcbgbq_year' },
            { path: '/jdjf', component: jdjf, name: 'jdjf' },
            { path: '/bnjf', component: bnjf, name: 'bnjf' },
            { path: '/bcylbx_year', component: bcylbx_year, name: 'bcylbx_year' },
            { path: '/insuranceClaims', component: insuranceClaims },
            { path: '/fpgl', component: fpgl },
            { path: '/sljl', component: sljl },
            { path: '/bcylsljl', component: bcylsljl },
            { path: '/bcgssljl', component: bcgssljl },
            { path: '/bcgsbjsljl', component: bcgsbjsljl },
            { path: '/xslpsqlc', component: xslpsqlc },

        ],
    },
]
const router = new VueRouter({
        routes,
        mode: 'history',

    })
    // 挂载路由导航守卫
router.beforeEach((to, from, next) => {
    // to:将要访问的路径
    // from:从哪里访问的路径
    // next:之后要做的任务，是一个函数
    //    next（）放行， next（'/URL'）强制跳转的路径。
    if (to.path == '/login') return next(); // 访问路径为登录
    // 获取flag

    const flagStr = window.sessionStorage.getItem("flag"); // session取值
    if (!flagStr) return next('/login'); // 没登录去登录

    next();

})

export default router // 暴露出去
